@import "../../common/reset.scss";

button {
  all: unset;
}

.pages {
  display: flex;
  align-items: center;
  @include reset-list;
}
